import InfoSection from "datalign-module-template/models/info-sections";
import { useEasierTheme } from "datalign-themes";
import React from "react";

const MainInfoSection = ({ infoSection }: { infoSection: InfoSection }) => {
  const theme = useEasierTheme();
  return (
    <section
      className="hero span-12"
      aria-labelledby="title"
      style={
        infoSection.colour
          ? {
              background: `
              radial-gradient(
                1000px 600px at 80% 10%,
                ${infoSection.colour === "primary" ? theme?.Colour.PrimaryContainer() : infoSection.colour === "secondary" ? theme?.Colour.SecondaryContainer() : infoSection.colour === "tertiary" ? theme?.Colour.TertiaryContainer() : "rgba(21, 101, 192, 0.35)"},
                transparent 60%
              ),
              linear-gradient(
                180deg,
                rgba(255, 255, 255, 0.06),
                rgba(255, 255, 255, 0.03)
              )`,
            }
          : undefined
      }
    >
      <div className="hero-inner">
        <div
          className="eyebrow"
          style={{
            color:
              infoSection?.colour === "primary"
                ? theme?.Colour.OnPrimaryContainer()
                : infoSection?.colour === "secondary"
                  ? theme?.Colour.OnSecondaryContainer()
                  : infoSection?.colour === "tertiary"
                    ? theme?.Colour.OnTertiaryContainer()
                    : undefined,
            background:
              infoSection?.colour === "primary"
                ? theme?.Colour.PrimaryContainer()
                : infoSection?.colour === "secondary"
                  ? theme?.Colour.SecondaryContainer()
                  : infoSection?.colour === "tertiary"
                    ? theme?.Colour.TertiaryContainer()
                    : undefined,
          }}
        >
          <span
            className="dot"
            style={{
              background:
                infoSection?.colour === "primary"
                  ? theme?.Colour.Primary()
                  : infoSection?.colour === "secondary"
                    ? theme?.Colour.Secondary()
                    : infoSection?.colour === "tertiary"
                      ? theme?.Colour.Tertiary()
                      : theme?.Colour.Shadow(),
              boxShadow: `0 0 0 4px ${
                infoSection?.colour === "primary"
                  ? theme?.colourPalette.getPrimary(85)
                  : infoSection?.colour === "secondary"
                    ? theme?.colourPalette.getSecondary(85)
                    : infoSection?.colour === "tertiary"
                      ? theme?.colourPalette.getTertiary(85)
                      : theme?.colourPalette.getNeutral(85)
              }`,
            }}
          ></span>{" "}
          Latest from the team
        </div>
        <h2
          id="title"
          style={{
            color:
              infoSection?.colour === "primary"
                ? theme?.Colour.OnPrimaryContainer()
                : infoSection?.colour === "secondary"
                  ? theme?.Colour.OnSecondaryContainer()
                  : infoSection?.colour === "tertiary"
                    ? theme?.Colour.OnTertiaryContainer()
                    : undefined,
          }}
        >
          {infoSection.name}
        </h2>
        <div className="lead">{infoSection.content}</div>
        {infoSection.ticker_text && infoSection.ticker_text.length > 0 && (
          <div className="ticker" role="region" aria-label="Recent updates">
            <div className="ticker-track">
              {infoSection.ticker_text &&
                infoSection.ticker_text.map((text) => (
                  <div className="tick">{text}</div>
                ))}
              {infoSection.ticker_text &&
                infoSection.ticker_text.map((text) => (
                  <div className="tick">{text}</div>
                ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default MainInfoSection;
